module.exports = __webpack_public_path__ + "72851a05ee8dc52c75dd39fe63ea63f8.png";